module.exports = __webpack_public_path__ + "img/Locfreeze.c9a0d3f4.png";